import { ROLE } from '@/utils/enum';
import { getEncryptedClientId, getRoleFromLocalStorage } from '@/utils/helper';
import { Navigate } from 'react-router-dom';

const NavigateDefault = () => {
  const role = getRoleFromLocalStorage();
  if (role === ROLE.BEACON) {
    const encryptedClientId = getEncryptedClientId();
    if (encryptedClientId) {
      return <Navigate to={`/${encryptedClientId}/beacon`} replace />;
    }
  }
  return <Navigate to='/' replace />;
};

export default NavigateDefault;
